import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import mangoWineImg from '../assets/mango-wine.png';
import beetrootWineImg from '../assets/beetroot-wine.png';
import blackGrapeWineImg from '../assets/black-grapes-wine.png';
import chikkuWineImg from '../assets/chikku-wine.png';
import gingerWineImg from '../assets/ginger-wine.png';
import greenGrapeWineImg from '../assets/green-grapes-wine.png';
import jamunWineImg from '../assets/jamun-wine.png';
import pineappleWineImg from '../assets/pineapple-wine.png';
import raisinsWineImg from '../assets/kishmish-wine.png';
import watermelonWineImg from '../assets/watermelon-wine.png';
import whiteJamunWineImg from '../assets/white-jamun.png'
import roseWineImg from '../assets/rose-wine.png'

const wine = [
    {
        id: "mango-wine",
        name: "Homemade - Mango Wine (Totapuri Mango)",
        image: mangoWineImg,
        ingredients: "Totapuri mango water, wheat, sugar, and Herbal Tea",
        fermentation: "Natural sugars in mango water and sugar converted to alcohol by yeast.",
        twist: "Herbal Tea adds a caramel and spice twist.",
        tastingTerms: [
            "Balanced acidity complements mango sweetness",
            "Strong fruity aroma with tropical hints",
            "Smooth finish from mango, wheat, sugar",
            "Bold fruity flavor with Herbal Tea"
        ],
        flavor: [
            "Fruit-Forward: Ripe Totapuri mango",
            "Spicy: Subtle Herbal Tea spice",
            "Sweet: Natural mango sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Appetizers, tropical fruits, spicy dishes"
        ],
        price: 250,
    },
    {
        id: "beetroot-wine",
        name: "Homemade - Beetroot Wine",
        image: beetrootWineImg,
        ingredients: "Fresh beetroot water, raisins, wheat, sugar, and Herbal Tea",
        fermentation: "Natural sugars in beetroot water and sugar converted to alcohol by yeast.",
        twist: "Herbal Tea adds a caramel and spice twist.",
        tastingTerms: [
            "Balanced acidity complements beetroot earthiness",
            "Earthy aroma with hints of sweet raisins",
            "Smooth finish from beetroot, raisins, wheat, sugar",
            "Bold earthy flavor with Herbal Tea"
        ],
        flavor: [
            "Earthy: Fresh beetroot undertone",
            "Spicy: Subtle Herbal Tea spice",
            "Sweet: Raisins and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Hearty salads, roasted vegetables, mild cheeses"
        ],
        price: 250,
    },
    {
        id: "black-grape-wine",
        name: "Homemade - Black Grape Wine",
        image: blackGrapeWineImg,
        ingredients: "Black grape water, wheat, sugar, and Herbal Tea",
        fermentation: "Natural sugars in grape water and sugar converted to alcohol by yeast.",
        twist: "Herbal Tea adds a caramel and spice twist.",
        tastingTerms: [
            "Balanced acidity complements grape sweetness",
            "Fruity aroma with dark berries",
            "Smooth finish from black grapes, wheat, sugar",
            "Bold fruity flavor with Herbal Tea"
        ],
        flavor: [
            "Fruit-Forward: Ripe black grapes",
            "Spicy: Subtle Herbal Tea spice",
            "Sweet: Grape and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Dark chocolate, grilled meats, strong cheeses"
        ],
        price: 450,
    },
    {
        id: "chikku-wine",
        name: "Homemade - Chikku Wine",
        image: chikkuWineImg,
        ingredients: "Chikku water, raisins, wheat, sugar, and Herbal Tea",
        fermentation: "Natural sugars in chikku water and sugar converted to alcohol by yeast.",
        twist: "Herbal Tea adds a caramel and spice twist.",
        tastingTerms: [
            "Balanced acidity complements chikku sweetness",
            "Fruity aroma with caramel and tropical hints",
            "Smooth finish from chikku, raisins, wheat, sugar",
            "Bold fruity flavor with Herbal Tea"
        ],
        flavor: [
            "Fruit-Forward: Ripe chikku with raisins",
            "Spicy: Subtle Herbal Tea spice",
            "Sweet: Chikku and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Fruit salads, light desserts, mild cheeses"
        ],
        price: 250,
    },
    {
        id: "ginger-wine",
        name: "Homemade - Ginger Wine",
        image: gingerWineImg,
        ingredients: "Fresh ginger water, raisins, wheat, sugar, and cinnamon",
        fermentation: "Natural sugars in ginger water and sugar converted to alcohol by yeast.",
        twist: "Cinnamon adds a warm, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements ginger spice",
            "Spicy aroma with ginger and cinnamon",
            "Smooth finish from ginger, raisins, wheat, sugar",
            "Bold spicy flavor with cinnamon"
        ],
        flavor: [
            "Spicy: Ginger and cinnamon",
            "Sweet: Raisins and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Spicy dishes, grilled meats, strong cheeses"
        ],
        price: 450,
    },
    {
        id: "green-grape-wine",
        name: "Homemade - Green Grape Wine",
        image: greenGrapeWineImg,
        ingredients: "Green grape water, wheat, sugar, and cinnamon",
        fermentation: "Natural sugars in grape water and sugar converted to alcohol by yeast.",
        twist: "Cinnamon adds a warm, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements grape freshness",
            "Fresh aroma with green apple and spice",
            "Smooth finish from grapes, wheat, sugar",
            "Bold fruity flavor with cinnamon"
        ],
        flavor: [
            "Fruit-Forward: Fresh green grapes",
            "Spicy: Cinnamon notes",
            "Sweet: Grape and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Light salads, seafood, mild cheeses"
        ],
        price: 450,
    },
    {
        id: "jamun-wine",
        name: "Homemade - Jamun Wine",
        image: jamunWineImg,
        ingredients: "Jamun water, Jamun seeds, wheat, sugar, and cinnamon",
        fermentation: "Natural sugars in Jamun water and sugar converted to alcohol by yeast.",
        twist: "Cinnamon adds a warm, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements Jamun tartness",
            "Rich aroma with dark berries and spice",
            "Smooth finish from Jamun, wheat, sugar",
            "Bold fruity flavor with cinnamon"
        ],
        flavor: [
            "Fruit-Forward: Ripe Jamun",
            "Spicy: Cinnamon notes",
            "Sweet: Jamun and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Grilled meats, dark chocolate, strong cheeses"
        ],
        price: 800,
    },
    {
        id: "pineapple-wine",
        name: "Homemade - Pineapple Wine",
        image: pineappleWineImg,
        ingredients: "Pineapple water, wheat, sugar, and ginger",
        fermentation: "Natural sugars in pineapple water and sugar converted to alcohol by yeast.",
        twist: "Ginger adds a refreshing, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements pineapple tanginess",
            "Tropical aroma with pineapple and spice",
            "Smooth finish from pineapple, wheat, sugar",
            "Bold fruity flavor with ginger"
        ],
        flavor: [
            "Fruit-Forward: Ripe pineapple",
            "Spicy: Ginger notes",
            "Sweet: Pineapple and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Fruit salads, seafood, light desserts"
        ],
        price: 350,
    },
    {
        id: "raisins-wine",
        name: "Homemade - Raisins Wine",
        image: raisinsWineImg,
        ingredients: "Raisins, wheat, sugar, water, and vanilla",
        fermentation: "Natural sugars in raisins and sugar converted to alcohol by yeast.",
        twist: "Vanilla adds a smooth, aromatic twist.",
        tastingTerms: [
            "Balanced acidity complements raisin sweetness",
            "Fruity aroma with dried fruit and vanilla",
            "Smooth finish from raisins, wheat, sugar",
            "Bold fruity flavor with vanilla"
        ],
        flavor: [
            "Fruit-Forward: Sweet raisins",
            "Aromatic: Vanilla notes",
            "Sweet: Raisins and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Cheese platters, desserts, roasted nuts"
        ],
        price: 350,
    },
    {
        id: "watermelon-wine",
        name: "Homemade - Watermelon Wine",
        image: watermelonWineImg,
        ingredients: "Watermelon water, raisins, wheat, sugar, and mint",
        fermentation: "Natural sugars in watermelon and sugar converted to alcohol by yeast.",
        twist: "Mint adds a refreshing, herbal twist.",
        tastingTerms: [
            "Balanced acidity complements watermelon freshness",
            "Light fruity aroma with mint",
            "Smooth finish from watermelon, raisins, wheat, sugar",
            "Bold fruity flavor with mint"
        ],
        flavor: [
            "Fruit-Forward: Fresh watermelon",
            "Herbal: Mint notes",
            "Sweet: Watermelon and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Light salads, grilled vegetables, mild cheeses"
        ],
        price: 250,
    },
    {
        id: "white-jamun-wine",
        name: "Homemade - White Jamun Wine",
        image: whiteJamunWineImg,
        ingredients:
            "White jamun fruit, wheat, sugar, and Herbal Tea",
        fermentation:
            "Sugars in white jamun ferment into alcohol, creating a crisp and subtly aromatic wine.",
        twist:
            "Herbal Tea adds gentle warmth and balances the fruit’s tanginess with subtle spice.",
        tastingTerms: [
            "Lively, refreshing acidity that brightens fruit flavors",
            "Delicate floral, citrus, and tropical aromas",
            "Light-bodied yet smooth balance of fruit and grain",
            "Elegant and distinctive compared to deeper berry wines"
        ],
        flavor: [
            "Tropical & Citrus: Mildly tart jamun with hints of lime and pear",
            "Floral: Hints of jasmine and white blossoms",
            "Dry or Semi-Sweet: Adjustable sugar for crispness or roundness",
            "Silky & Refreshing: Velvety, easy-drinking texture"
        ],
        serving: [
            "Chilled: Best served ice-cold",
            "Pairings: Grilled seafood, white sauce dishes, goat cheese, light salads"
        ],
        price: 350,
    },
    {
        id: "rose-wine",
        name: "Homemade - Rosé Wine with Black Raisins & Rose Petals",
        image: roseWineImg, // <-- Replace with actual image import or path
        ingredients: "Black raisins, wheat, sugar, herbal tea, red & pink rose petals",
        fermentation: "Soaked raisins and sugar are fermented; rose petals are gently macerated to infuse floral notes.",
        twist: "Herbal tea provides subtle spice and caramel undertones; rose petals add elegance.",
        tastingTerms: [
            "Crisp acidity highlights berry and floral tones",
            "Floral bouquet from rose petals with rich raisin sweetness",
            "Balanced depth from raisins, refined by rose",
            "Elegant body with expressive floral aroma"
        ],
        flavor: [
            "Berry-Forward: Strawberry, raspberry, raisin sweetness",
            "Floral: Rose petals and gentle herbal undertones",
            "Dry or Semi-Sweet: Adjustable sweetness to taste",
            "Silky: Smooth, velvety finish from slow fermentation"
        ],
        serving: [
            "Chilled: Always served ice-cold",
            "Pairings: Seafood, grilled vegetables, creamy pasta, soft cheeses like Brie"
        ],
        price: 700, // Suggested price, adjust as needed
    }


];

const Products = () => {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const wineId = params.get("wine");

        if (wineId) {
            const element = document.getElementById(wineId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [location]);

    return (
        <section className="bg-white px-6 py-12 space-y-24">
            {/* Page Heading */}
            <div className="text-center max-w-3xl mx-auto mb-16">
                <h1 className="text-4xl sm:text-5xl font-extrabold text-[--primary-wine] mb-4">
                    Premium Homemade Fruit Wines 🍇🍷
                </h1>
                <p className="text-lg text-gray-600 leading-relaxed">
                    Discover the unique essence of handcrafted wines made from fresh fruits, carefully fermented with herbal blends like cinnamon, mint, or tea. Each bottle is a story of tradition, flavor, and innovation.
                </p>
            </div>
            {wine.map((item, index) => (
                <div
                    id={item.id}
                    key={index}
                    className={`grid grid-cols-1 lg:grid-cols-3 gap-8 items-center max-w-6xl mx-auto rounded-xl shadow-sm py-8 px-4 sm:p-10 ${index % 2 === 0 ? 'bg-white' : 'bg-[--neutral-light-gray]'
                        }`}
                >
                    {/* Column 1: Details */}
                    <div className="space-y-4 text-gray-800 text-sm">
                        <div>
                            <h2 className="font-bold text-[--primary-wine] mb-1">
                                Wine Origins & What’s in the Bottle
                            </h2>
                            <p>
                                <strong>Ingredients:</strong> {item.ingredients}<br />
                                <strong>Fermentation:</strong> {item.fermentation}<br />
                                <strong>Unique Twist:</strong> {item.twist}
                            </p>
                        </div>
                        <div>
                            <h2 className="font-bold text-[--primary-wine] mb-1">Tasting Terms</h2>
                            <ul className="list-disc pl-5">
                                {item.tastingTerms.map((term, i) => (
                                    <li key={i}>{term}</li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h2 className="font-bold text-[--primary-wine] mb-1">Flavor Descriptions</h2>
                            <ul className="list-disc pl-5">
                                {item.flavor.map((f, i) => (
                                    <li key={i}>{f}</li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h2 className="font-bold text-[--primary-wine] mb-1">Serving Suggestions</h2>
                            <ul className="list-disc pl-5">
                                {item.serving.map((s, i) => (
                                    <li key={i}>{s}</li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Column 2: Image */}
                    <div className="flex items-center flex-col">
                        <img
                            src={item.image}
                            alt={item.name}
                            className="w-2/3 lg:w-full object-contain"
                        />

                        <h3 className="text-2xl text-[var(--primary-wine)] font-semibold"><span className='text-[14px]'>Rs</span> <span className='text-3xl font-bold'>{item.price}</span></h3>
                    </div>

                    {/* Column 3: Title + CTA */}
                    <div className="flex flex-col justify-center items-start gap-6">
                        <h1 className="text-3xl font-bold text-[--primary-wine-dark]">{item.name}</h1>
                        <a
                            href={`https://wa.me/919881055454?text=Hi! I'm interested in buying: ${encodeURIComponent(item.name)} for Rs ${item.price}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-6 py-2 bg-[--primary-wine] text-white font-semibold rounded hover:bg-[--primary-wine-hover] transition inline-block"
                        >
                            Buy Now
                        </a>
                    </div>
                </div>
            ))}
        </section>
    );
};

export default Products;